import axiosInstance from 'utils/axiosInstance';
import { ProjectDTO, ProjectListDTO, Users,ProjectsUserRequest, tableFilter, ProjectsResponse, ResponseStats } from '../';

const CreateProjectService = async (
  values: ProjectDTO,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post('/api/project/addNewProject', values);
  return data;
};

const listProjectsService = async  (
  filters: tableFilter,
): Promise<ApiResponse<ProjectsResponse>> => {
  const { data } = await axiosInstance.post<ApiResponse<ProjectsResponse>>(
    '/api/project/listprojects',
      filters
  );
  return data; 
};

const deleteProjectService = async (
  id: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.delete(`/api/project/deleteProject/${id}`);
  return data;
};

const UpdateProjectService = async (
  values: ProjectListDTO,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post('/api/project/UpdateProject', values);
  return data;
};

const affectedUsersServices = async (values: {
  projectId: number;
  userIds: string[];
}): Promise<ApiResponse<Users[]>> => {
  const { data } = await axiosInstance.post(
    `/api/project/assign?projectId=${values.projectId}`, 
    values.userIds, 
  );
  return data;
};

const DeleteAssignedUserService = async ({
  idUser,
  idProject,
}: {
  idUser: string;
  idProject: number;
}): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post('/api/Project/deletemember', {
    projectId: idProject,
    memberId: idUser,
  });

  return data;
};

const GetByIdServices = async (projectId: number) => {
  const { data } = await axiosInstance.post(
    `/api/project/getbyId?projectId=${projectId}`
  );
  return data;
  
};
 const getProjectsUser = async (values: ProjectsUserRequest) => {
  try {
    const { data } = await axiosInstance.post<ApiResponse<SelectItem[]>>(
      '/api/project/projectsUser',
      values,
    );
    return data;
  } catch (error) {
    console.error('Error fetching projects user data:', error);
    throw error;
  }
};

const getStatistic = async (): Promise<ApiResponse<ResponseStats>> => {
  const { data } = await axiosInstance.get<ApiResponse<ResponseStats>>(
    'api/project/ProjectsStatistics',
  );
  return data;
};


export {
  CreateProjectService,
  listProjectsService,
  deleteProjectService,
  UpdateProjectService,
  affectedUsersServices,
  DeleteAssignedUserService,
  GetByIdServices,
  getProjectsUser,
  getStatistic
};
